<template>
    <div>
        <table-onsite />
    </div>
</template>
<script>
import tableOnsite from "../components/TableOnsite"
export default {
    components: {
        "table-onsite": tableOnsite,
    },
}
</script>
